module.exports = __webpack_public_path__ + "img/mod-6.2d7e77ee.svg";